import { PublicPage } from "@/components/PublicPage";

export default function Permis() {
  return (
    <PublicPage
      eyebrow="Permis B"
      title="Passe ton permis B, plus vite et plus sereinement"
      intro="Que tu débutes, que tu aies déjà ton code ou quelques heures de conduite, PlanPermis te met en relation avec une auto-école partenaire adaptée à ta situation — boîte manuelle ou automatique."
      bullets={[
        { title: "Boîte manuelle ou automatique", sub: "Tu choisis le type de conduite qui te correspond." },
        { title: "Une auto-école proche", sub: "On sélectionne un partenaire dans ta zone, selon la distance souhaitée." },
        { title: "Une date d'examen rapide", sub: "On privilégie les auto-écoles qui ont des places disponibles en formation accélérée." },
        { title: "Réserve ta date en ligne", sub: "C'est 100% gratuit : tu déposes ton dossier et on te met en relation avec l'auto-école." },
      ]}
    />
  );
}
